<template>
    <div>
        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
        <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{warningmsg}}</b-alert>
        <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{dangermsg}}</b-alert>
        
        <div class="row">
            <div class="col-md-10 col-sm-12" >
                <h4 class="atlhr-dashboard-title mt-10">Employee GF Loan Breakdown<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Employee GF Loan Transactions</span></h4>
            </div>
            <div class="col-md-2 col-sm-12 d-flex align-items-end justify-content-end" >
                <div class="pl-0 pr-2 company-employee-count" style="height: 31px; position: unset;"></div>
            </div>
        </div>
        
        <div  class="clearfix row no-gutters" v-if="employee_id>0">            
            <loan-public-info :pageurl="this.$api_url"  :employee_id="employee_id" :key="c_flg"></loan-public-info>
        </div>
        <div class="row  py-3">
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span> 
                <div class="dash-widget-info">
                <h3>{{formatMoney(loan.loan_amount)}}</h3>
                <span>Total Loan Amount</span>
                </div>
                </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{formatMoney(loan_breakdown.debit_amount)}}</h3>
                <span>Paid Amount</span>
                </div>
                </div>
                </div>
            </div>

            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;&#2547&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{formatMoney(loan_breakdown.remaining_amount)}}</h3>
                <span>Remaining Amount</span>
                </div>
                </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6 py-3">
                <div class="card dash-widget">
                <div class="card-body">
                <span class="dash-widget-icon" style="height: 55px; width: 55px;">&nbsp;#&nbsp;</span>
                <div class="dash-widget-info">
                <h3>{{loan_breakdown.debit_month}} / {{loan.loan_tenure}}</h3>
                <span>Transactions</span>
                </div>
                </div>
                </div>
            </div>
        </div>
       
     <template active v-if="$atl_company_package_title != 'Gratuity Fund Only'" >
    
        <b-overlay rounded="sm">
            <div v-if="transactions.length > 0" class=" p-3">    
                                  
                <div class="row table-head">
                    <div class="col-sm-3 font-weight-bold py-2">
                        Payrun Name
                    </div>                      
                    <div class="col-sm-2 font-weight-bold py-2">
                        Payslip Name
                    </div>
                    <div class="col-sm-3 font-weight-bold py-2">
                        Download Payslip file
                    </div>
                    <div class="col-sm-1 font-weight-bold py-2">
                        Amount
                    </div>
                    <div class="col-sm-1 font-weight-bold py-2">
                        Type
                    </div>
                    <div class="col-sm-2 font-weight-bold py-2">
                        Month
                    </div>
                </div>
            
                <div class="row table-row hover-bg" v-for="transaction in transactions" :key="transaction.id">
                    <div class="col-sm-3 py-2 align-items-center d-flex" v-if="transaction.payrun_id >0">                    
                        <div class="">{{pay_runs[transaction.payrun_id].name}}</div>
                    </div>
                    <div class="col-sm-3 py-2 align-items-center d-flex" v-if="transaction.payrun_id ==0">                    
                        <div class="">N/A</div>
                    </div>
                    <div class="col-sm-2 py-2 align-items-center d-flex" v-if="transaction.payslip_id >0">
                        <div class=""> {{pay_slips[transaction.payslip_id].pay_slip_name}}</div>
                    </div>
                    <div class="col-sm-2 py-2 align-items-center d-flex" v-if="transaction.payslip_id ==0">
                         <div class="">N/A</div>
                    </div>
                    <div class="col-sm-3 py-2 align-items-center d-flex" v-if="transaction.payslip_id > 0">
                         <b-button class="border rounded bg-light float-right py-1 px-2"  type="submit" variant="primary" @click="downloadPaySlip(transaction.payslip_id,pay_slips[transaction.payslip_id].fiscal_year)"><i class="far fa-file-pdf px-1" aria-hidden="true" style="font-size:16px;color:red"></i> Download PDF</b-button>
                    </div>
                    <div class="col-sm-3 py-2 align-items-center d-flex" v-if="transaction.payslip_id ==0">
                         <div class="">N/A</div>
                    </div>
                    <div class="col-sm-1 py-2 align-items-center d-flex">
                        {{formatMoney(transaction.amount)}} 
                    </div>
                    <div class="col-sm-1 py-2 align-items-center d-flex">
                        {{tx_type[transaction.tx_type]}} 
                    </div>
                     <div class="col-sm-2 py-1 align-items-center d-flex">
                        {{transaction.month}} 
                    </div>
                
                </div>                        
            </div>
            <div v-else class=" p-4">  
                Sorry no transaction to show.
            </div>
             
            
        </b-overlay> 

        </template>  
    </div>
    
</template>
<script>

    

    
    export default{

        mounted() {
            //this.showoverlay = false;  
            setTimeout(this.showContent , 3000);    
            
        },
        props: ['pageurl' ,'readonly','loan_id','employee_id'],
        
        data(){            
            
            return {
                styleA: 'color:#55ce63 !important',
                styleB: 'color:#212529 !important',
                installments:[],
                showoverlay : true,
                cu:window.location.href,
                ce : true,
                transactions:[],
                loan:[],
                loan_breakdown:[],
                employee_info:[],
                pay_runs:[],
                pay_slips:[],
                loan_title:'',
                company_title:'',
                total_loan_title:'',
                pageUrl : this.$api_url,
                pgeUrl : this.$api_url,
                avatarsrc : null,
                ewtabIndex : 0,
                public_info : [{name:'', email:'', jobposition:'', department:'', company:'', join_date:'', contract_expire:''}],
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Retured"],
                tx_type : ["Manual Payment","Debit","Credit"],
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                action_loader:'',
                modal_title:'',
                count:0,
                loan_status:0,
                is_custom:0,
                is_status:0,
                flg:0,
                loading :'',
                
                c_flg: 0, // This variable is for reloading public info

            }
        },
        methods:{
            
        
            showContent: function()
            {
                this.showoverlay = false;
            },
            updateTransactions()
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/gf/loan/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-loan');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;   
                    if(this.ce == false) this.ewtabIndex = 0;

                }.bind(this));
            }, 
            formatMoney: function(amount){
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                money = amount;
                else{
                if(money.indexOf(".")<0)
                money = money+".00";
                }
                return money;
            },  
            toMoney: function(amount){
                if(amount !="0")
                {
                    if(!isNaN(amount))
                    {
                        var number = Number(amount);
                        return number;
                    }
                var NumWithoutCommas = amount.replace(/,/g, ''); 
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
                }else
                    return amount;
            },
            getLoanTransactionData: function(loan_id,employee_id)
            {
            
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                formData.append('loan_id', loan_id); 
                formData.append('employee_id', employee_id); 

                axios.post(this.$api_url+'/gf/loan//transactionslist' ,formData).then(function(response){ 
                    this.transactions = response.data.transactions;
                    this.loan_id = response.data.loan_details.loan_id;
                    this.loan_status = response.data.loan_details.status;
                    this.loan = response.data.loan_details;
                    this.loan_breakdown = response.data.loan_breakdown;
                    this.employee_info = response.data.employee_info;
                    this.pay_runs = response.data.pay_runs;
                    this.pay_slips = response.data.pay_slips;
                    this.c_flg += 1; 

                }.bind(this)).catch(function (error){currentObj.serverError(error);});


            },
            download_file(fileURL, fileName) { 
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href; 
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }	
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
           },
            downloadPaySlip: function(p_slip,f_year,email_file=false,prnt_file=false)
            {
                    this.action_loader = true; 
                    var send_file = email_file ? 1: 0;
                    axios.get(this.$api_url+'/payslippdf/'+f_year+'/'+p_slip , {
                            params: {
                                em_file:  send_file
                            }
                    }).then(function(response){
                    
                    this.action_loader = false;
                    if(response.data.file_name){
                
                    if(response.data.download_name) 
                    this.download_file_name = response.data.download_name;
                    else
                    this.download_file_name = this.payslip_title;
                    
                    
                    if(prnt_file)
                    this.download_file(response.data.file_name,this.download_file_name+'.pdf');
                    else if(email_file){
                    if(response.data.success)
                    this.$bvToast.toast(response.data.success, {
                                        title: 'Success',
                                        variant: 'success',
                                        solid: true
                                    });
                    else if(response.data.error)
                    this.$bvToast.toast(response.data.error, {
                                        title: 'Error!',
                                        variant: 'danger',
                                        solid: true
                                    });
                    }
                    else
                    this.download_file(response.data.file_name,this.download_file_name+'.pdf');
                    }
                    else if(response.data.error){
                    this.$bvToast.toast(response.data.error, {
                                        title: 'Error!',
                                        variant: 'danger',
                                        solid: true
                                    });
                    }else{
                    this.$bvToast.toast('Unexpected server error!', {
                                        title: 'Error!',
                                        variant: 'danger',
                                        solid: true
                                    });
                    }
                    //console.log(response.data.file_name);
                }.bind(this));
            }, 
        },
        created: function(){
            //
            this.getAcl();
            this.getLoanTransactionData(this.loan_id,this.employee_id);
            this.updateTransactions();
            
        }

    }

</script>